export default function titleCase(v: string) {
    const words = v.toLowerCase().split(' ');
    const titleCaseWords = words.map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return titleCaseWords.join(' ');
}
